/**
 * "Seu acesso a esta empresa foi encerrado" (spec 042) — a lógica pura, sem
 * React, para ser provada fora do navegador (o web não tem executor de testes;
 * o teste mora na API, apps/api/src/shared/access-ended.test.ts).
 *
 * A API responde 401 `membership_inactive` quando o vínculo da pessoa com a
 * empresa da requisição foi desligado (ou a conta inteira). É um 401, mas NÃO
 * é sessão vencida: mandar a pessoa de volta ao login do Keycloak, que ainda
 * tem a sessão dela, devolveria-a para o mesmo 401 — um laço. Por isso este
 * código tem tratamento próprio no api-client e uma tela própria.
 */
export const ACCESS_ENDED_CODE = 'membership_inactive';

/** A resposta é a do acesso encerrado (e não a de sessão vencida)? */
export function isAccessEnded(status: number, body: unknown): boolean {
  return (
    status === 401 &&
    typeof body === 'object' &&
    body !== null &&
    (body as { error?: unknown }).error === ACCESS_ENDED_CODE
  );
}

/**
 * O que a tela oferece. Com uma empresa escolhida no navegador (quem está em
 * mais de uma), "Entrar em outra empresa" esquece a escolha e recarrega: a API
 * cai sozinha na empresa que continua ativa, ou pergunta qual. Sem escolha
 * guardada, a empresa encerrada era a única — só resta sair.
 */
export function accessEndedActions(selectedTenant: string | null): Array<'switch' | 'logout'> {
  return selectedTenant ? ['switch', 'logout'] : ['logout'];
}
